import { addDays, addMinutes, format, isAfter, parseISO } from 'date-fns';

type DateFormatType = 'time' | 'date' | 'full' | 'short' | 'custom';

export const formatDate = (isoString: string, formatType: DateFormatType = 'date', customFormat?: string): string => {
  if (!isoString) return 'N/A';
  const parsed = parseISO(isoString);

  switch (formatType) {
    case 'time':
      return format(parsed, 'h:mm a'); // 9:50 AM
    case 'date':
      return format(parsed, 'MMMM d, yyyy'); // April 17, 2025
    case 'full':
      return format(parsed, 'MMMM d, yyyy h:mm:ss a'); // April 17, 2025 9:50:12 AM
    case 'short':
      return format(parsed, 'MM/dd/yyyy'); // 04/17/2025
    case 'custom':
      return customFormat ? format(parsed, customFormat) : isoString;
    default:
      return isoString;
  }
};

export const getVerificationExpiryTime = (isoString: string, minutesToAdd = 30): string => {
  if (!isoString) return 'N/A';
  const date = parseISO(isoString);
  const expiresAt = addMinutes(date, minutesToAdd);
  return format(expiresAt, 'h:mm a');
};

export const getVerificationExpiryDate = (isoString: string, daysToAdd = 90): string => {
  if (!isoString) return 'N/A';
  const date = parseISO(isoString);
  const expiryDate = addDays(date, daysToAdd);
  return format(expiryDate, 'PPPp'); // June 5, 2025 at 2:31 PM
};

export const isPastExpiry = (isoString: string, daysToAdd = 90): boolean => {
  if (!isoString) return false;
  const expiryDate = addDays(parseISO(isoString), daysToAdd);
  return isAfter(new Date(), expiryDate);
};
